import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusRenew: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusRenew"><Path d="M16 13.5V17L12.5 13.5H16Z" fill="currentColor"/><Path d="M8 10.5V7L11.5 10.5H8Z" fill="currentColor"/><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M14.6727 15C13.9572 15.6224 13.0145 16 12 16C10.1362 16 8.57008 14.7252 8.12604 13M9.10071 9.21302C9.83729 8.46484 10.8745 8 12 8C13.8639 8 15.43 9.27477 15.874 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusRenew;
